import DigiobcanApi, { type UserCandidate } from '../../api/DigiobcanApi';
import { createQueryFn, QueryNameSpace } from '../../lib/query';
import type { QueryFunctionContext } from '@tanstack/react-query';

export type { UserCandidate };

type Params = {
  q?: string;
  limit?: number;
};

/**
 * Kandidáti na priradenie ku kategórii podnetov, teda držitelia úradníckych
 * oprávnení. Okruh určuje digiobcan-api, nie tento dotaz.
 *
 * Zoznam účtov predtým chodil z datahub-api (`CoreApi.getAccounts`)
 * delegovaným tokenom pre cimpo. Prehliadač tak držal token, ktorým sa dala
 * enumerovať používateľská báza - preto to ide cez digiobcan-api a preto sa
 * `CoreApi.getAccounts` už nikde nepoužíva.
 *
 * `pageParam` je offset; stránkuje sa dosýtením na scroll.
 */
export const searchUsers = createQueryFn(
  QueryNameSpace.searchUsers,
  async ({
    queryKey,
    pageParam,
  }: QueryFunctionContext<[string] | [string, Params]>) => {
    const [, params] = queryKey;

    return await DigiobcanApi.searchUsers({
      ...params,
      offset: (pageParam as number) ?? 0,
    });
  },
);
